import { CalendarStatusResponse } from "@clockwise/schema";
import { IconComponent } from "@clockwise/web-commons/src/icons/phosphor";
import {
  DesktopTower,
  ForkKnife,
  Lightbulb,
  MoonStars,
  Note,
  SunHorizon,
  XCircle,
} from "phosphor-react";

export const STATUS_TO_ICON: { [K in CalendarStatusResponse]: IconComponent } = {
  FocusTime: Lightbulb,
  Meeting: Note,
  OutOfOffice: XCircle,
  Weekend: SunHorizon,
  DayOff: SunHorizon,
  WorkingHours: DesktopTower,
  Lunch: ForkKnife,
  BeforeWorkingHours: MoonStars,
  AfterHours: MoonStars,
  Holiday: XCircle,
  Other: Note,
};

export const STATUS_TO_DESCRIPTION: { [K in CalendarStatusResponse]: string } = {
  FocusTime: "Focus Time",
  Meeting: "In a meeting",
  OutOfOffice: "Out of office",
  Weekend: "Weekend",
  DayOff: "Day off",
  WorkingHours: "In working hours",
  Lunch: "Lunch",
  BeforeWorkingHours: "Before working hours",
  AfterHours: "After hours",
  Holiday: "Holiday",
  Other: "",
};
